export default {
  CASH_REGISTER_READINGS_LIST: "Cash register readings list",
  ADD_CASH_REGISTER_READING: "Add cash register reading",
  CASH_REGISTER_READING_ADDED: "Cash register reading added",
  EDIT_CASH_REGISTER_READING: "Edit cash register reading",
  CASH_REGISTER_READING_UPDATED: "Cash register reading updated",
  DELETE_THIS_CASH_REGISTER_READING: "Delete this cash register reading?",
  CASH_REGISTER_READING_DELETED: "Cash register reading deleted",
  STARTS_AT: "Starts at",
  ENDS_AT: "Ends at",
  CREATED_BY: "Created by",
  UPDATED_BY: "Updated by",
  TOTAL_AMOUNT: "Total amount",
  TITLE: "Title",
  CASH_REGISTER_CATEGORY_PEDAGO: "Education",
  EVENT_CATEGORY_THEMATIC_MEAL: "Thematic meal",
  EVENT_CATEGORY_TASTING: "Tasting",
  EVENT_CATEGORY_PROMOTION: "Promotion",
  EVENT_CATEGORY_EVENT: "Event",
  EVENT_CATEGORY_INTERNAL_JOURNAL: "Internal journal",
  EVENT_CATEGORY_CLIENT_JOURNAL: "Client journal",
  EVENT_CATEGORY_SURVEY: "Survey",
  EVENT_CATEGORY_MONTHLY_INSPIRATION: "Monthly inspiration",
  EVENT_CATEGORY_OPEN_HOUSE: "Open house",
  SHOW_MY_EVENTS: "Show registers assigned to me",
  SHOW_CASH_REGISTER: "View register",
  SHOW_ALL: "Show all registers",
  EXPENSE_LINE: "Expense line",
  TOTAL_EXPENSES: "Total expenses",
  TOTAL_SALES: "Total sales",
  CASH_BALANCE: "Net sales",
  CASH: "Terminal debit",
  MASTERCARD_CARD: "Mastercard credit card",
  VISA_CARD: "Visa credit card",
  DEBIT_CARD: "Terminal debit card",
  PREPAIED_CARD: "Laniel card purchase",
  OTHER: "Other",
  TOTAL_CASHOUT: "Total cash-out",
  CANCEL_CASH_REGISTER_READING_QUESTION: "Cancel the cash register reading?",
  VALIDATE_CASH_REGISTER_READING_QUESTION: "Validate the cash register reading?",
  STATUS_DRAFT: "Draft",
  STATUS_CANCELED: "Canceled",
  STATUS_VALIDATED: "Validated",
  REGISTER_ERRORS: "Punch errors",
  CASHIN: "Cash register reading (Z or Net1 or gross sales)",
  CASHOUT: "Paid invoice (external purchase)",
  NUMBER_Z: "Z number",
  COINS: "Coins",
  AMOUNT_ACCOUNT: "Cash on hand",
  NET_BRUT: "Cash register reading (Z or Net1 or gross sales)",
  TOTAL_AMOUNT_ACCOUNT: "Total cash on hand",
  TOTAL_PAYMENT_METHODS: "Total payment methods",
  PAYMENT_METHODS: "Payment methods",
  SUBMITION: "Submissions",
  EXPECTED_ACCOUNT: "ACCOUNTS RECEIVABLE",
  AMOUNT_GAP: "Gap with total sales",
  TOTAL_OF_SALES: "Total sales",
  TRANSACTION_COUNT: "Transaction count",
  GAPS_WHEN_VALIDATE: "There is a gap of {gap} with the total sales, do you want to validate the cash register reading?",
  GAPS_WHEN_CANCEL: "There is a gap of {gap} with the total sales, do you want to cancel the cash register reading?",
  CHECKOUT_PERSON: "Cashier",
  CASH_REGISTERS_CHECK: "Register readings",
  CASH_REGISTERS_NEED_READING: "Some registers do not have a reading today",
  CREATE_READING: "Create a reading",
  ALL_CASH_REGISTERS_CHECKED: "All registers were checked today",
  AUTO_CREATED_READING: "Reading automatically created from the dashboard",
  READING_CREATED_SUCCESSFULLY: "Cash register reading created successfully",
  GAP_NOTE_LABEL: "Discrepancy note",
  GAP_NOTE_PLACEHOLDER: "Explain the gap",
  GAP_NOTE_REQUIRED_HINT: "Please provide the justification for the gap",
  GAP_NOTE_REQUIRED_MESSAGE: "Please provide the justification for the sales gap before validating.",
  RECORD_SALES_WIDGET_TITLE: "Record sales",
  RECORD_SALES_VIEW_ALL: "View full ranking",
  RECORD_SALES_MODAL_TITLE: "Record ranking of all schools",
  RECORD_SALES_NO_DATA: "No validated readings yet",
  RECORD_SALES_NO_SALES_PERIOD: "No validated sales for this period",
  RECORD_SALES_SINCE: "{duration} ago",
  RECORD_SALES_TODAY: "today",
  RECORD_SALES_YEARS: "{count} year | {count} years",
  RECORD_SALES_MONTHS: "{count} month | {count} months",
  RECORD_SALES_DAYS: "{count} day | {count} days",
  RECORD_SALES_AND: "and",
  RECORD_SALES_PERIOD_MONTH: "Month record",
  RECORD_SALES_PERIOD_MONTH_OF: "{month} record",
  RECORD_SALES_PERIOD_MONTH_OF_VOWEL: "{month} record",
  RECORD_SALES_PERIOD_SCHOOL_YEAR: "School year record",
  RECORD_SALES_PERIOD_ALL_TIME: "All-time record",
  RECORD_SALES_NEW_RECORD: "New record!",
  RECORD_SALES_NEW_FIRST_PLACE: "New 1st place!",
  RECORD_SALES_FIRST_TOOLTIP_TITLE_MONTH: "New 1st place this month!",
  RECORD_SALES_FIRST_TOOLTIP_TITLE_SCHOOL_YEAR: "New 1st place this school year!",
  RECORD_SALES_FIRST_TOOLTIP_TITLE_ALL_TIME: "New 1st place in the all-time ranking!",
  RECORD_SALES_FIRST_TOOLTIP_TOOK: "Your school took the lead on {date}. Previous 1st place: {school} ({amount}).",
  RECORD_SALES_CHEER_TOOK_FIRST: "You just took 1st place, well done! Right behind you: {school}.",
  RECORD_SALES_CELEBRATION_TOOK_FIRST: "You took 1st place in the ranking! Previous 1st place: {school} ({amount}).",
  RECORD_SALES_TOOLTIP_TITLE_MONTH: "New month record!",
  RECORD_SALES_TOOLTIP_TITLE_SCHOOL_YEAR: "New school year record!",
  RECORD_SALES_TOOLTIP_TITLE_ALL_TIME: "New all-time record!",
  RECORD_SALES_TOOLTIP_WHAT_MONTH: "The month record is your school's best sales day since {month} 1.",
  RECORD_SALES_TOOLTIP_WHAT_SCHOOL_YEAR: "The school year record is your school's best sales day since August 1, {year}.",
  RECORD_SALES_TOOLTIP_WHAT_ALL_TIME: "The all-time record is your school's best sales day, all years combined.",
  RECORD_SALES_TOOLTIP_BEATEN: "Your school beat it on {date} with {amount}; the previous record was {previous} ({previousDate}).",
  RECORD_SALES_TOOLTIP_DURATION: "This badge stays visible for {days} days after the record.",
  RECORD_SALES_TOOLTIP_CLICK: "Click the badge to celebrate!",
  RECORD_SALES_CELEBRATION_TITLE: "Congratulations!",
  RECORD_SALES_CELEBRATION_BEATEN: "You beat your previous record of {amount} from {date}!",
  RECORD_SALES_CELEBRATION_NEW: "Your new record",
  RECORD_SALES_CELEBRATION_MSG_TEAM: "The whole team can be proud of this result.",
  RECORD_SALES_CELEBRATION_MSG_WORK: "It is the result of your everyday work: thank you and well done!",
  RECORD_SALES_CELEBRATION_MSG_FIRST: "And your school ranks 1st out of {count} schools!",
  RECORD_SALES_CELEBRATION_MSG_NEXT: "Keep it up, the next record is not far away!",
  RECORD_SALES_CELEBRATION_CLOSE: "Thanks!",
  RECORD_SALES_DESC_MONTH: "Your school's best sales day since {month} 1.",
  RECORD_SALES_DESC_SCHOOL_YEAR: "Best sales day since the school year began, on August 1, {year}.",
  RECORD_SALES_DESC_ALL_TIME: "Your school's best sales day, all years combined.",
  RECORD_SALES_CHEER_NEW_AND_FIRST: "New record and 1st place: congratulations to the whole team!",
  RECORD_SALES_CHEER_NEW_MONTH: "Congratulations, new month record! The whole team can be proud.",
  RECORD_SALES_CHEER_NEW_SCHOOL_YEAR: "Congratulations, new school year record! Keep it going.",
  RECORD_SALES_CHEER_NEW_ALL_TIME: "All-time record broken: a first for your school, congratulations!",
  RECORD_SALES_CHEER_FIRST: "Congratulations, your school is in 1st place! Keep it up.",
  RECORD_SALES_CHEER_LAST_DAY_TOP_MONTH: "On a roll: your last day ranks {rank} this month!",
  RECORD_SALES_CHEER_LAST_DAY_TOP_SCHOOL_YEAR: "On a roll: your last day ranks {rank} this school year!",
  RECORD_SALES_CHEER_LAST_DAY_TOP_ALL_TIME: "On a roll: your last day ranks {rank} in your school's history!",
  RECORD_SALES_CHEER_GAP: "Only {gap} to go to move up to {rank}! Just ahead: {school}.",
  RECORD_SALES_SCHOOL_RANK: "{rank} of {count} schools",
  RECORD_SALES_RANK_OUT_OF: "of {count} schools",
  RECORD_SALES_LAST_DAY: "Last day",
  RECORD_SALES_LAST_DAY_RANK: "Last day: {rank} of {count}",
  RECORD_SALES_BEST_DAYS: "My best days",
  RECORD_SALES_RANKING: "School ranking",
  RECORD_SALES_MY_SCHOOL: "My school",
  RECORD_SALES_ORDINAL_FIRST: "1st",
  RECORD_SALES_ORDINAL: "#{rank}",
  COUPON_TO_INVOICE: "Coupon (To be invoiced)",
  ACTUAL_RECEIVED_AMOUNT: "Actual amount received",
  ACTUAL_RECEIVED_AMOUNT_HINT: "Total cash-in minus coupons to be invoiced",
  REGISTER_DATA_TITLE: "Register data",
  REGISTER_PREVIEW_LOADING: "Looking for the sales recorded by the register…",
  REGISTER_PREVIEW_FOUND:
    "Sales found in the register: Z of {z}, {count} transactions, last sale at {time}.",
  REGISTER_PREVIEW_AUTOFILL_HINT:
    "Amounts will be filled in automatically when saving. The drawer still has to be counted.",
  REGISTER_PREVIEW_NO_SALES:
    "No sales in the register for this day: the reading will have to be filled in by hand.",
  REGISTER_PREFILL_BUTTON: "Fill from the register",
  REGISTER_REFRESH_BUTTON: "Refresh from the register",
  REGISTER_PREFILL_CONFIRM_TITLE: "Fill the reading from the register?",
  REGISTER_PREFILL_CONFIRM_CHANGES: "These fields will change:",
  REGISTER_PREFILL_NO_CHANGES: "The reading already matches the register.",
  REGISTER_PREFILL_MANUAL_FIELDS_KEPT:
    "The drawer count, cashier, punch errors, expenses and note are not changed.",
  REGISTER_PREFILL_DONE: "Reading filled from the register",
  REGISTER_PREFILL_FAILED_AFTER_CREATE:
    "Reading created, but the amounts could not be read from the register: {reason}",
  REGISTER_NO_SALES_FOR_READING:
    "No sales in the register for the day of this reading.",
  REGISTER_PREFILLED_AT: "Filled from the register on {date}.",
  REGISTER_LAST_SALE: "Last recorded sale: {time}.",
  REGISTER_EXPECTED_CASH: "Cash expected by the register",
  REGISTER_COUNTED_CASH: "Counted cash",
  REGISTER_CASH_GAP: "Gap",
  REGISTER_RELOADS_EXCLUDED: "Card reloads excluded from the Z: {amount}",
  REGISTER_UNMAPPED_PAYMENTS:
    "Payment methods with no field in the reading, to be moved to the right field:",
  REGISTER_INCOHERENT:
    "In the register, total sales ({z}) do not match the sum of payments ({payments}). Check the Z report.",
  REGISTER_FIELD_BADGE: "Register",
  REGISTER_FIELD_BADGE_TOOLTIP: "Value read from the register",
  REGISTER_ERROR_CASH_REGISTER_NOT_LINKED_TO_ISTHERA:
    "This cash register is not linked to the register software.",
  REGISTER_ERROR_CASH_REGISTER_READING_NOT_DRAFT:
    "Only a draft reading can be filled from the register.",
  REGISTER_ERROR_ISTHERA_UNAVAILABLE:
    "The register software is not responding. Try again in a few minutes or fill in the reading by hand.",
  REGISTER_NUMBER_Z_CHECK:
    "According to the register, the Z number of this day is {expected} (entered: {typed}). Check the Z report.",
  REGISTER_BASIS_DAY:
    "No Z report dated this day in the register: amounts are the sales of the calendar day.",
  REGISTER_PARTIAL_PREFILL:
    "Partial prefill: only the Z number, the Z total and the transaction count come from the register. Payments are entered by hand.",
  REGISTER_PREVIEW_PARTIAL_AUTOFILL_HINT:
    "The Z number, the Z total and the transaction count will be filled in on save. Payments and the drawer count remain to be entered.",
  REGISTER_SUMMARY_TITLE: "What comes from the register",
  REGISTER_SUMMARY_NOT_PREFILLED: "This reading was not filled from the register.",
  REGISTER_SUMMARY_MODE_FULL: "Full prefill.",
  REGISTER_SUMMARY_MODE_PARTIAL: "Partial prefill: Z number, Z total and transactions.",
  REGISTER_SUMMARY_ALL_SAME: "Every value is the register's.",
  REGISTER_SUMMARY_CHANGED_COUNT:
    "{count} value changed by hand since the prefill | {count} values changed by hand since the prefill",
  REGISTER_SUMMARY_FIELD: "Field",
  REGISTER_SUMMARY_REGISTER_VALUE: "According to the register",
  REGISTER_SUMMARY_READING_VALUE: "In the reading",
  REGISTER_SUMMARY_CHANGED: "Changed",
};
